export default __webpack_public_path__ + "static/media/SoundCloud.e9ec3fbd.png";